import * as SentryReact from '@sentry/react';

// Initialize Sentry SDK
SentryReact.init({
  dsn: "https://53ec017fc662094ca9a719aa172f6954@o0.ingest.sentry.io/0",
  integrations: [
    SentryReact.browserTracingIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

export const addBreadcrumb = (breadcrumb: SentryReact.Breadcrumb) => {
  SentryReact.addBreadcrumb(breadcrumb);
  if (typeof window !== 'undefined' && (window as any).Sentry?.addBreadcrumb) {
    try {
      (window as any).Sentry.addBreadcrumb(breadcrumb);
    } catch (_) {}
  }
};

export const captureException = (exception: any, context?: { extra?: Record<string, any>; level?: SentryReact.SeverityLevel }) => {
  let eventId = '';
  SentryReact.withScope((scope) => {
    if (context?.extra) {
      scope.setExtras(context.extra);
    }
    if (context?.level) {
      scope.setLevel(context.level);
    }
    eventId = SentryReact.captureException(exception);
  });

  if (typeof window !== 'undefined' && (window as any).Sentry?.captureException) {
    try {
      (window as any).Sentry.captureException(exception);
    } catch (_) {}
  }
  return eventId;
};

export const captureMessage = (message: string, captureContext?: any) => {
  const eventId = SentryReact.captureMessage(message, captureContext);
  if (typeof window !== 'undefined' && (window as any).Sentry?.captureMessage) {
    try {
      (window as any).Sentry.captureMessage(message, captureContext);
    } catch (_) {}
  }
  return eventId;
};

// Send an initial startup message to verify integration in Sentry Dashboard
try {
  captureMessage('Sentry integration initialized on Media Magnet app', {
    level: 'info',
    extra: { timestamp: new Date().toISOString() }
  });
} catch (_) {}

export { SentryReact as Sentry };
